import React from "react";
import { Card, Typography } from "antd";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

function passengerTitleLine(p) {
  const t = String(p.titlePrefix || "").trim();
  return t || "—";
}

/**
 * @param {{ passengers: Array<Record<string, unknown>> }} props
 */
export default function OperationRequestPassengersCard({ passengers }) {
  return (
    <Card className={styles.sidebarCard} size="small" title="נוסעים בהזמנה">
      {!passengers?.length ? (
        <Text type="secondary">לא נמצאו נוסעים</Text>
      ) : (
        passengers.map((p, idx) => (
          <div key={p.id} className={styles.passengerRow}>
            <div className={styles.passengerNum}>{idx + 1}</div>
            <div style={{ minWidth: 0 }}>
              <Text strong style={{ display: "block" }}>
                {p.displayName || "—"}
              </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {[
                passengerTitleLine(p),
                String(p.oldFirstName || "").trim(),
                String(p.oldLastName || "").trim(),
              ]
                .filter(Boolean)
                .join(" · ") || "—"}
            </Text>
              <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
                {p.role} · {p.roomLabel}
              </Text>
            </div>
          </div>
        ))
      )}
    </Card>
  );
}
